export const environment = {
  production: true,
  api_base:  "https://api.frontpagestats.com/api/",
  env_name: "prod"
};



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/environments/environment.ts